module.exports = __webpack_public_path__ + "prod/1.42.2/img/distribution-four.317c9c93.png";